import React from "react"
import { Node } from "@jsplumbtoolkit/core"
import "./MultiSelectPanel.scss"
import { RiCheckboxMultipleBlankLine } from "react-icons/ri"
import { QuestsModel } from "../../../../../Models/Quests/Quests.Model"
import { BrowserUIReact } from "@jsplumbtoolkit/browser-ui-react"
import { QuestDataFromPlumb } from "../../Canvas/Methods/QuestDataFromPlumb"
import _ from 'lodash'
import { useSwivlNavigate } from "../../../../../Models/NavBar/useSwivlNavigate"
import { QuestModelHelper } from "../../../../../Models/Quests/Helpers/QuestModel.Helper"
import { QuestInterface, QuestType, InheritanceStatus } from "@swivl-mono/types"
import { Input, Dropdown, Button, ButtonColor } from "@swivl-mono/ui"
import NodeModel from "../../Nodes/NodeModel"

interface Props {
  toolkit: BrowserUIReact
  selectedNodes: Node[]
  deleteNodes(nodeOrNodes: Node | Node[]): void
  quest: QuestInterface;
  saveQuest(): void;
}
interface MergeProps {
  toolkit: BrowserUIReact
  quest: QuestInterface;
  selectedNodes: Node[]
  cancelMerge(): void
  deleteNodes(nodeOrNodes: Node | Node[]): void
  saveQuest(): void;
}

function MergeQuestView(props: MergeProps) {
  const { selectedNodes, quest, cancelMerge, toolkit, deleteNodes } = props
  const [newQuestName, setNewQuestName] = React.useState("New Quest")
  const journeys = QuestsModel.useState(s => s.journeys)
  const [journeySlug, setJourneySlug] = React.useState(quest.journeySlug)
  const [isCreating, setIsCreating] = React.useState(false);
  const navigate = useSwivlNavigate()

  const createQuest = async () => {
    setIsCreating(true)
    var data = toolkit.exportData();
    let allNodes = QuestDataFromPlumb(data)
    let ids = selectedNodes.map(n => n.id)
    let nodes: any = {}

    _.forIn(allNodes, (value, key) => {
      if (ids.includes(key)) {
        nodes[key] = value
      }
    });
    let newQuest = QuestModelHelper.newQuest(newQuestName, QuestType.NORMAL, quest.journeySlug!, InheritanceStatus.NONE, quest.order + 1);
    newQuest.data = { ...newQuest.data, ...nodes }
    const newQ = await QuestsModel.createQuest(newQuest)
    let averageLeft = 0;
    let averageTop = 0;

    selectedNodes.forEach(n => {
      averageLeft += n.data.left;
      averageTop += n.data.top;

    })
    averageLeft = averageLeft / selectedNodes.length;
    averageTop = averageTop / selectedNodes.length;

    deleteNodes(selectedNodes)
    const model = NodeModel.forType("quest")
    let questNode = model.Empty()
    questNode.questSlug = newQ.slug;
    let newPlumbNode = model.PlumbData(questNode).node;
    newPlumbNode.left = averageLeft;
    newPlumbNode.top = averageTop;
    toolkit.addNode(newPlumbNode)

    await props.saveQuest();

    navigate("/quest/" + newQ.slug)
  }

  return (
    <div className="content">
      <h3>Merge {selectedNodes.length} Nodes into New Quest</h3>

      <label>Quest Name</label>
      <Input placeholder="New quest name..." value={newQuestName} onChange={(e) => setNewQuestName(e.target.value)} />
      <label>Journey</label>
      <Dropdown options={Object.values(journeys!).map(i => ({
        label: i.name,
        value: i.slug,
      }))}
        value={journeySlug}
        optionSelected={(option) => {
          setJourneySlug(option.value)
        }} />
      <Button
        color={ButtonColor.ORANGE}
        fullWidth
        onClick={createQuest}
        loading={isCreating}
      >
        Save
      </Button>

      <Button color={ButtonColor.BLACK} fullWidth onClick={cancelMerge}>Cancel</Button>
      <hr />

      Clicking save will create a new quest with the selected nodes merged into it. The nodes in this quest will be replaced with a Quest node.
    </div>
  )
}

export function MultiSelectPanel(props: Props) {
  const { selectedNodes, deleteNodes, toolkit } = props
  const [showMerge, setShowMerge] = React.useState(false)

  return (
    <div className="MultiSelectPanel">
      {showMerge ? (
        <MergeQuestView
          selectedNodes={selectedNodes}
          quest={props.quest}
          toolkit={toolkit}
          deleteNodes={deleteNodes}
          saveQuest={props.saveQuest}
          cancelMerge={() => {
            setShowMerge(false)
          }}
        />
      ) : (
        <div className="content">
          <span className="icon">
            <RiCheckboxMultipleBlankLine />
          </span>
          <h3>{selectedNodes.length} Nodes Selected</h3>
          <Button color={ButtonColor.ORANGE} fullWidth onClick={() => { setShowMerge(true) }}>Merge To Quest</Button>

          <Button fullWidth onClick={() => { deleteNodes(selectedNodes) }}>Delete</Button>
        </div>
      )}
    </div>
  )
}
